var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVoicemail2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.677734 8.0021C0.677734 6.10678 2.2142 4.57031 4.10952 4.57031C6.00484 4.57031 7.54131 6.10678 7.54131 8.0021C7.54131 8.51315 7.4296 8.9981 7.22927 9.43388H8.77134C8.57102 8.9981 8.45931 8.51315 8.45931 8.0021C8.45931 6.10678 9.99577 4.57031 11.8911 4.57031C13.7864 4.57031 15.3229 6.10678 15.3229 8.0021C15.3229 9.89742 13.7864 11.4339 11.8911 11.4339H4.10952C2.2142 11.4339 0.677734 9.89742 0.677734 8.0021ZM4.10952 9.43388C4.90027 9.43388 5.54131 8.79285 5.54131 8.0021C5.54131 7.21135 4.90027 6.57031 4.10952 6.57031C3.31877 6.57031 2.67773 7.21135 2.67773 8.0021C2.67773 8.79285 3.31877 9.43388 4.10952 9.43388ZM11.8911 6.57031C11.1003 6.57031 10.4593 7.21135 10.4593 8.0021C10.4593 8.79285 11.1003 9.43388 11.8911 9.43388C12.6818 9.43388 13.3229 8.79285 13.3229 8.0021C13.3229 7.21135 12.6818 6.57031 11.8911 6.57031Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVoicemail2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Voicemail2.8559c26c1ba9ed01927c9a1fc4e87d92.svg";